import React, { Fragment, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/barcode.css";
import { SidebarLayout } from "./SidebarLayout";
import DetailsContent from "./child/DetailsContent";
import { getBackToItemsPage, getDetailsContentProps } from "../js/helper";

export const DetailsPage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const sourceBtn = state?.source_btn;

  const backToItemsPage = getBackToItemsPage(navigate);
  const detailsContentProps = getDetailsContentProps(state, backToItemsPage);

  useEffect(() => {
    if (sourceBtn === "push-qr") {
      window.isQrFlowActive = true;
    }
    return () => {
      window.isQrFlowActive = false;
    };
  }, [sourceBtn]);

  return (
    <div className="QR-Code-Page d-flex" style={{ backgroundColor: "rgb(250, 250, 252)" }}>
      <SidebarLayout sideNavPosition={1}>
        {sourceBtn == "push-qr" ? (
          <Fragment>
            <div className="page-title">QR Generator</div>
            <div className="item-details">
              <div className="item-details-desc">
                <div className="QR_title">QR Code</div>
                <div className="sub-title py-2">
                  Kailangang ipa-scan sa customer ito
                </div>
              </div>
              <DetailsContent {...detailsContentProps} />
            </div>
          </Fragment>
        ) : (
          <Fragment>
            <div className="page-title">Send SMS</div>
            <div className="item-details">
              <DetailsContent {...detailsContentProps} />
            </div>
          </Fragment>
        )}

        <div className="Next-btn d-flex w-100">
          <div className="next-page-btn  text-end w-100">
            <button className="btn btn-dark" onClick={backToItemsPage}>
              Done <i className="fa fa-arrow-right" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </SidebarLayout>
    </div>
  )
};

export default DetailsPage;